import * as React from 'react';
import { useFormikContext } from 'formik';

import { areas } from '@/common/data/preferences';
import { Checkbox, Title } from '@/shared/ui/elements';

import NoPreferenceButton from './NoPreferenceButton';

import {
  CheckBoxContainer,
  CheckboxList,
  ButtonContainer,
} from '../ShiftPreferencesModal.styled';
import NextButton from './NextButton';

export const SelectAreas = ({ forEdit }) => {
  const { setFieldValue, handleSubmit } = useFormikContext();

  return (
    <div>
      <Title>What are your area(s) of practice?</Title>

      <CheckboxList columns={1} gap={8}>
        {areas.map((option) => {
          const name = `areas__${option.value}`;
          return (
            <CheckBoxContainer key={option.value}>
              <Checkbox
                label={option.label}
                role="checkbox"
                type="checkbox"
                name={name}
                onChange={(event) => setFieldValue(name, event.target.checked)}
              />
            </CheckBoxContainer>
          );
        })}
      </CheckboxList>

      <ButtonContainer>
        <NextButton
          type="submit"
          forEdit={forEdit}
          noEditLabel="Save My Preferences"
        />
        {!forEdit && (
          <NoPreferenceButton
            afterOnClick={handleSubmit}
            options={areas}
            field="areas"
          />
        )}
      </ButtonContainer>
    </div>
  );
};

